module.exports = {
	"name": "minecraft-manager-web",
	"version": "0.2.1",
	"description": "minecraft-manager web-ui",
	"author": "XGHeaven <xgheaven@gmail.com>",
	"private": true,
	"scripts": {
		"dev": "node build/dev-server.js",
		"start": "node build/dev-server.js",
		"build": "node build/build.js",
		"unit": "cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run",
		"e2e": "node test/e2e/runner.js",
		"test": "npm run unit && npm run e2e",
		"lint": "eslint --ext .js,.vue src test/unit/specs test/e2e/specs",
		"deploy": "gh-pages -d dist"
	},
	"dependencies": {
		"element-ui": "^1.2.8",
		"path-to-regexp": "^1.7.0",
		"vue": "^2.2.2",
		"vue-resource": "^1.3.1",
		"vue-router": "^2.3.0",
		"vuex": "^2.3.0"
	},
	"devDependencies": {
		"autoprefixer": "^6.7.2",
		"babel-core": "^6.22.1",
		"babel-eslint": "^7.1.1",
		"babel-loader": "^6.2.10",
		"babel-plugin-istanbul": "^3.1.2",
		"babel-plugin-transform-runtime": "^6.22.0",
		"babel-preset-env": "^1.2.1",
		"babel-preset-stage-2": "^6.22.0",
		"babel-register": "^6.22.0",
		"chai": "^3.5.0",
		"chalk": "^1.1.3",
		"chromedriver": "^2.27.2",
		"connect-history-api-fallback": "^1.3.0",
		"copy-webpack-plugin": "^4.0.1",
		"cross-env": "^3.1.4",
		"cross-spawn": "^5.0.1",
		"css-loader": "^0.26.1",
		"eslint": "^3.14.1",
		"eslint-config-standard": "^6.2.1",
		"eslint-friendly-formatter": "^2.0.7",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^2.0.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-standard": "^2.0.1",
		"eventsource-polyfill": "^0.9.6",
		"express": "^4.14.1",
		"extract-text-webpack-plugin": "^2.0.0",
		"file-loader": "^0.10.0",
		"friendly-errors-webpack-plugin": "^1.1.3",
		"gh-pages": "^0.12.0",
		"html-webpack-plugin": "^2.28.0",
		"http-proxy-middleware": "^0.17.3",
		"inject-loader": "^2.0.1",
		"karma": "^1.4.1",
		"karma-coverage": "^1.1.1",
		"karma-mocha": "^1.3.0",
		"karma-phantomjs-launcher": "^1.0.2",
		"karma-phantomjs-shim": "^1.4.0",
		"karma-sinon-chai": "^1.2.4",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-spec-reporter": "0.0.26",
		"karma-webpack": "^2.0.2",
		"lolex": "^1.5.2",
		"mocha": "^3.2.0",
		"nightwatch": "^0.9.12",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^1.3.0",
		"ora": "^1.1.0",
		"phantomjs-prebuilt": "^2.1.14",
		"rimraf": "^2.6.0",
		"selenium-server": "^3.0.1",
		"semver": "^5.3.0",
		"shelljs": "^0.7.6",
		"sinon": "^2.1.0",
		"sinon-chai": "^2.8.0",
		"stylus": "^0.54.5",
		"stylus-loader": "^3.0.1",
		"url-loader": "^0.5.8",
		"vue-loader": "^11.1.4",
		"vue-style-loader": "^2.0.0",
		"vue-template-compiler": "^2.2.4",
		"vuex": "^2.3.0",
		"webpack": "^2.2.1",
		"webpack-bundle-analyzer": "^2.2.1",
		"webpack-dev-middleware": "^1.10.0",
		"webpack-hot-middleware": "^2.16.1",
		"webpack-merge": "^2.6.1"
	},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"browserslist": [
		"> 1%",
		"last 2 versions",
		"not ie <= 8"
	]
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 82
// module chunks = 1